<template>
    <div class="row">
        <div class="col-sm-12 col-md-12" v-if="bloqueado">
            <div class="alert-message alert-message-danger">
                <h4>Cliente Bloqueado</h4>
                <p></p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        bloqueado: {
            default: false
        }
    }
};
</script>
